import { DataTable } from "@/components/tables";
import { Stack, Typography } from "@altimateai/lego";
import UploadUsersButton from "./UploadUsersButton";
import DeleteWithConfirm from "./DeleteWithConfirm";
import { NoUserImage } from "./assets";
import { formatUserName, isUserDeleted } from "@/helpers/utils";
import { User } from "@/types";

interface MembersSectionProps {
  members?: User[];
  canManageUsers: boolean;
  groupId?: string;
  refetch: () => void;
  isGroupDeleted: boolean;
}

const MembersSection = ({
  members,
  canManageUsers,
  groupId,
  refetch,
  isGroupDeleted,
}: MembersSectionProps) => (
  <section aria-label="Members" className="al-bg-light al-p-3 al-rounded al-mt-4">
    <Stack justify="between" className="al-mb-3">
      <Typography variant="section-heading">Members</Typography>
      {!isGroupDeleted && <UploadUsersButton />}
    </Stack>

    <div className="al-bg-white">
      {(!members || members.length === 0) && (
        <Stack direction="column" justify="center" align="center" className="al-p-4 al-rounded">
          <NoUserImage />
          No members found!
        </Stack>
      )}

      {members && members.length > 0 && (
        <DataTable<User>
          data={{ items: members }}
          header={[
            {
              id: 1,
              uid: "name",
              label: "Name",
              render: item => (
                <div className="al-break-words">
                  {isUserDeleted(item) ? `${formatUserName(item)} (deleted)` : formatUserName(item)}
                </div>
              ),
            },
            {
              id: 2,
              uid: "email",
              label: "Email",
              render: item => <div className="al-break-words">{item.email}</div>,
            },
            {
              id: 3,
              uid: "actions",
              label: "Actions",
              render: item => (
                <div>
                  {canManageUsers && !isUserDeleted(item) ? (
                    <DeleteWithConfirm
                      entityId={item.id.toString()}
                      id={groupId || ""}
                      refetch={refetch}
                      entityType="user"
                      title={`Delete member ${item.email}`}
                    />
                  ) : null}
                </div>
              ),
            },
          ]}
        />
      )}
    </div>
  </section>
);

export default MembersSection;
